    document.addEventListener("DOMContentLoaded", function () {
      let currentOpenMenu = null;
      let activeMenuItem = null;

      // Easing function for smooth animation
      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      // Function to animate the mega menu content with a strong ease effect
      function animateMenuContent(content, start, end, duration, callback) {
        let startTime;

        function animate(time) {
          if (!startTime) startTime = time;
          const timeElapsed = time - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          const easedProgress = easeInOutCubic(progress);
          const translateY = start + (end - start) * easedProgress;

          content.style.transform = `translateY(${translateY}%)`;

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            if (callback) {
              callback();
            }
          }
        }

        content.style.transition = "none";
        requestAnimationFrame(animate);
      }

      // Function to handle click to toggle menu
      function handleMenuClick(event) {
        const clickedItem = event.target.closest(".header__menu-item");
        if (!clickedItem) return;
        const megaMenuContent = clickedItem
          .closest(".header-menu")
          .querySelector(".mega-menu__content");

        if (currentOpenMenu && currentOpenMenu !== megaMenuContent) {
          animateMenuContent(currentOpenMenu, 0, -100, 600);
        }

        if (megaMenuContent.style.transform === "translateY(0%)") {
          animateMenuContent(megaMenuContent, 0, -100, 600, function () {
            currentOpenMenu = null;
          });
        } else {
          animateMenuContent(megaMenuContent, -100, 0, 600);
          currentOpenMenu = megaMenuContent;
        }

        // Handle the active class for the clicked item
        if (activeMenuItem) {
          activeMenuItem.classList.remove("active");
        }
        clickedItem.classList.add("active");
        activeMenuItem = clickedItem;

        event.stopPropagation();
      }

      // Function to handle document click to close menu if clicking outside
      function handleDocumentClick(event) {
        if (currentOpenMenu && !event.target.closest(".header-menu")) {
          animateMenuContent(currentOpenMenu, 0, -100, 600, function () {
            currentOpenMenu = null;
          });
          if (activeMenuItem) {
            activeMenuItem.classList.remove("active");
            activeMenuItem = null;
          }
        }
      }

      // Select all .header__menu-item elements
      const menuItems = document.querySelectorAll(".header__menu-item");

      // Add click event listeners to each .header__menu-item
      menuItems.forEach(function (item) {
        item.addEventListener("click", handleMenuClick);
      });

      // Add click event listener to the document
      document.addEventListener("click", handleDocumentClick);
    });

    // 10 Product minimum and update cart button text
    document.addEventListener("DOMContentLoaded", function () {
      // Set initial minimum required quantity
      const minimumQuantity = 10;

      // Function to update the cart button text
      function updateCartButtonText(totalItems) {
        const checkoutButton = document.getElementById("CartDrawer-link");

        if (checkoutButton) {
          if (totalItems < minimumQuantity) {
            let itemsRemaining = minimumQuantity - totalItems;
            checkoutButton.textContent = `ADD ${itemsRemaining} MORE TO CONTINUE`;
            checkoutButton.classList.add("disabled"); // Disable checkout button until requirement met
          } else {
            checkoutButton.textContent = "GO TO CART";
            checkoutButton.classList.remove("disabled"); // Enable checkout button
          }
        }
      }

      // Ensure a minimum of 10 products in the cart
      function checkMinimumQuantity() {
        let totalItems = 0;
        const cartBubble = document.querySelector(
          '.cart-count-bubble span[aria-hidden="true"]'
        );

        if (cartBubble) {
          totalItems = parseInt(cartBubble.textContent, 10);
        }

        updateCartButtonText(totalItems); // Update button text based on current total items
      }

      // Function to observe cart changes
      function observeCartChanges() {
        const targetNode = document.getElementById("CartDrawer");
        if (targetNode) {
          const config = { childList: true, subtree: true };

          const callback = function (mutationsList, observer) {
            setTimeout(checkMinimumQuantity, 500); // Delay to account for cart updates
          };

          const observer = new MutationObserver(callback);
          observer.observe(targetNode, config);
        }
      }

      // Trigger on quantity change
      if (
        window.location.pathname.includes("/send-10-to-my-office") ||
        window.location.pathname === "/cart"
      ) {
        document.querySelectorAll(".cart__qty-input").forEach(function (element) {
          element.addEventListener("change", function () {
            setTimeout(checkMinimumQuantity, 500); // Delay to account for cart updates
          });
        });
        checkMinimumQuantity(); // Initial check on page load
        observeCartChanges(); // Observe cart changes
      }
    });

    // Clear cart if navigating away from send-10-to-my-office page
    document.addEventListener("DOMContentLoaded", function () {
      function clearCart() {
        return fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
          .then(function (response) {
            if (!response.ok) {
              console.error("Failed to clear cart.");
            } else {
              console.log("Cart cleared.");
            }
          })
          .catch(function (error) {
            console.error("Error clearing cart:", error);
          });
      }

      function handleNavigation(event) {
        const destination = event.target.href || "";
        if (
          !destination.includes("/cart") &&
          !destination.includes("/send-10-to-my-office")
        ) {
          clearCart(); // Clear cart but allow normal link behavior
        }
      }

      if (window.location.pathname.includes("/send-10-to-my-office")) {
        window.addEventListener("beforeunload", function () {
          clearCart();
        });

        document.querySelectorAll("a").forEach((link) => {
          link.addEventListener("click", handleNavigation);
        });
      }
    });

    // Fragment Identifier Caching and Populating
    document.addEventListener("DOMContentLoaded", function () {
      // Function to get the fragment identifier without the '#'
      function getFragment() {
        return window.location.hash.substring(1); // Removes the '#' character
      }

      // Function to cache the fragment in localStorage
      function cacheFragment(fragment) {
        if (fragment) { // Ensure there's a fragment to store
          try {
            localStorage.setItem('cachedFragment', fragment);
            console.log('Fragment cached:', fragment);
          } catch (e) {
            console.error('Failed to cache fragment:', e);
          }
        } else {
          console.log('No fragment identifier found in the URL to cache.');
        }
      }

      // Function to retrieve the cached fragment from localStorage
      function getCachedFragment() {
        try {
          return localStorage.getItem('cachedFragment');
        } catch (e) {
          console.error('Failed to retrieve cached fragment:', e);
          return null;
        }
      }

      // Function to populate the input field with the cached fragment
      function populateSenderField() {
        const cachedFragment = getCachedFragment();
        const senderInput = document.getElementById('ContactForm-sender');

        if (senderInput) {
          if (cachedFragment) {
            senderInput.value = cachedFragment;
            console.log('Sender\'s Name populated:', cachedFragment);
            console.log('success');
          } else {
            console.log('No cached fragment found to populate the Sender\'s Name.');
          }
        } else {
          console.error('Input field with ID "ContactForm-sender" not found.');
        }
      }

      // Initial execution on page load
      function handleInitialFragment() {
        const fragment = getFragment();
        cacheFragment(fragment);
        console.log('Fragment Identifier:', fragment);
      }

      // Handle changes to the fragment identifier
      function handleHashChange() {
        const newFragment = getFragment();
        cacheFragment(newFragment);
        console.log('Fragment Identifier:', newFragment);
      }

      // Execute initial fragment handling
      handleInitialFragment();

      // Populate the sender field if the input exists on the page
      populateSenderField();

      // Listen for changes to the fragment identifier
      window.addEventListener('hashchange', handleHashChange);
    });



